import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../../../selectors/pages/home/welcome_bonus';
import WelcomeSelector from '../../../../../../../selectors/modals/welcome_bonus';
import {toggleActionModal} from '../../../../../../../reducers/modals-action/actions';
import ModalsLib from '../../../../../../../lib/modals';
import Timer from './timer';
import WhiteButton from '../../../../../../components/white-button';
import {getWelcomeBonusTimestamp} from '../../../../../../../utils/user';

export default () => {
    const {isAuth} = useSelector(Selector),
          welcome_bonus = useSelector(WelcomeSelector),
          dispatch = useDispatch();

    if(!welcome_bonus.available)
        return <></>;
    
    return (
        <div className="slide deposit size-params">
            <div className="size-params-layer layer0">
                <div className="gift"></div>
            </div>
            <div className="layer-margin size-params-layer layer1">
                <div className="gift"></div>
            </div>
            <div className="layer-margin size-params-layer layer2">
                <div className="girl"></div>
            </div>
            <div className="layer-margin size-params slide-details">
                <div className="title">
                    Welcome<br/>
                    to Lucksy
                </div>
                <div className="descriptions">Get +{welcome_bonus.deposit}% up to 1 000 USD</div>
                <div className="descriptions-short">Collect your first deposit<br />bonus right now</div>
                <div className="details">
                    {/* <WhiteButton onClick={e => {
                        if(isAuth)
                            dispatch(toggleActionModal('welcome-package'));
                            // ModalsLib.open('wallet')
                        else
                            ModalsLib.open('signin')
                    }}>
                        Claim now
                    </WhiteButton> */}
                    <div className="button" onClick={e => {
                        if(isAuth)
                            dispatch(toggleActionModal('welcome-package'));
                            // ModalsLib.open('wallet')
                        else
                            ModalsLib.open('signup')
                    }}>Claim now</div>
                    <Timer timestamp={getWelcomeBonusTimestamp()} />
                </div>
            </div>
        </div>
    )
}